import { Injectable } from '@angular/core';
import { IWorkDelivery } from './work-delivery';
import { Observable, BehaviorSubject, Subject } from 'rxjs';
import { WorkItemModel, CreateBlankWorkItem } from '../models/work-item';
import { WorkGetNextService } from 'e5core-angular-services';
import { Guid } from 'guid-typescript';
import { UiWorkItemService } from 'e5core-angular-services' ;
import { UiStyle } from '../enums/ui-style';

/**
 * This service is used to provide work into the work item Subject/
 */
@Injectable({
  providedIn: 'root'
})
export class WorkDeliveryService implements IWorkDelivery {

  constructor(
    private getNextService: WorkGetNextService,
    private uiWorkItemService: UiWorkItemService) {

  }

  public getNextWorkItem(workItem$: BehaviorSubject<WorkItemModel>, lock?:boolean): Observable<WorkItemModel> {
    const subject$ = new Subject<WorkItemModel>() ;

    this.getNextService.getNextWorkItem({ lockWorkItem : lock }).subscribe(
      response => {
        const wi = response.workItem ;
        if (wi && wi.id && !wi.id.isEmpty) {
          this.uiWorkItemService.getAll(wi.id).subscribe(
            wim => {
              const current = workItem$.getValue() ;
              const updated:WorkItemModel = {
                ...current,
                ...wim
              }
              workItem$.next(updated) ;
              subject$.next(updated) ;
            },
            error => { subject$.error(error) },
            () => { subject$.complete() }
          )
        } else {
          let blank = CreateBlankWorkItem() ;
          workItem$.next(blank) ;
          subject$.next(blank) ;
        }
      },
      error => subject$.error(error)
    ) ;

    return (subject$) ;
  }

  getWorkItem(workId: string, workItem$: BehaviorSubject<WorkItemModel>, lock?:boolean): Observable<WorkItemModel>  {
    const subject$ = new Subject<WorkItemModel>() ;

    this.uiWorkItemService.getAll(workId).subscribe(
      wim => {
        const updated:WorkItemModel = {
          ...workItem$.getValue(),
          ...wim
        }
        workItem$.next(updated) ;
        subject$.next(updated) ;
      },
      error => { subject$.error(error) },
      () => { subject$.complete() }
    )

    return (subject$) ;
  }

}
